import * as Sentry from '@sentry/browser';
import * as APIClient from 'Services/APIClient';
import { exponentialBackoffThreeTimes } from 'utils/retryPolicies';
import {
  FEATURE_FLAGS_FETCH_FAIL,
  FEATURE_FLAGS_FETCH_START,
  FEATURE_FLAGS_FETCH_SUCCESS,
} from './actionTypes';

export const fetchFeatureFlags = () => async (dispatch, _getState) => {
  dispatch({ type: FEATURE_FLAGS_FETCH_START });
  try {
    const response = await exponentialBackoffThreeTimes(() => APIClient.get('/flags'));
    const fetchedFeatureFlags = await response.json();
    return dispatch({ type: FEATURE_FLAGS_FETCH_SUCCESS, fetchedFeatureFlags });
  } catch (error) {
    Sentry.withScope(scope => {
      scope.setLevel('info');
      Sentry.captureMessage(`[Flipt] ${error.toString()}`);
    });
    return dispatch({ type: FEATURE_FLAGS_FETCH_FAIL, error });
  }
};
